import { render, staticRenderFns } from "./Vcalendar.vue?vue&type=template&id=fff4ab46&scoped=true&"
import script from "./Vcalendar.vue?vue&type=script&lang=js&"
export * from "./Vcalendar.vue?vue&type=script&lang=js&"
import style0 from "./Vcalendar.vue?vue&type=style&index=0&id=fff4ab46&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff4ab46",
  null
  
)

export default component.exports